import { pathOr } from 'ramda';
import { createSelector } from 'reselect';
import { combineReducers } from 'redux';
import { SET_ANALYTICS_CONNECTED } from '../../../constants/analytics';

export const initialState = {
  isConnected: false,
};

export const stateReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ANALYTICS_CONNECTED: {
      return {
        ...state,
        isConnected: true,
      };
    }
    default: {
      return state;
    }
  }
};

export const analyticsSelector = (state) =>
  pathOr(initialState, ['domain', 'analytics', 'states'], state);

export const isAnalyticsConnectedSelector = createSelector(
  analyticsSelector,
  (state) => pathOr(initialState.isConnected, ['isConnected'], state)
);

export default combineReducers({
  states: stateReducer,
});
